import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as StarUnselected } from "@fortawesome/free-regular-svg-icons";
import { faStar as StarSelected } from "@fortawesome/free-solid-svg-icons";
import ReviewService from "../services/ReviewService";
import firebase from "../services/FirebaseService";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/reviews.css";

const ReviewsList = () => {


	const reviewService = new ReviewService();
	
	const [ reviews, setReviews ] = useState([]);
	const [ pending, setPending ] = useState(true);
	const [ limit, setLimit ] = useState(3);
	const [ loadingMore, setLoadingMore ] = useState(false);

	
	useEffect(() => {

		(async () => {
			if(pending) {
				try {
					
		console.log(limit);	
					const reviewsList = await reviewService.getReviews(limit);
		
					setReviews(reviewsList);
					setPending(false);
				}
				catch(error) {
					console.error(error);
				}
			}
			
		})();
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadMore = async (e) => {
		e.preventDefault();
		
		const newLimit = limit + 2;

		setLimit(newLimit);
		setLoadingMore(true);

		try {
			const reviewsList = await reviewService.getReviews(limit + 2);

			setReviews(reviewsList);
			setLoadingMore(false);
		}
		catch(error) {
			console.error(error);
		}

	};

	return (
		<section id="reviews-list-individuals">
			{ !pending && reviews.map(review => 
					<div className="review">
						<h3>{review.name}</h3>
						<h4><FontAwesomeIcon className={review.stars >= 1 ? "active" : ""} icon={review.stars >= 1 ? StarSelected : StarUnselected} />
						<FontAwesomeIcon className={review.stars >= 2 ? "active" : ""} icon={review.stars >= 2 ? StarSelected : StarUnselected} />
						<FontAwesomeIcon className={review.stars >= 3 ? "active" : ""} icon={review.stars >= 3 ? StarSelected : StarUnselected} />
						<FontAwesomeIcon className={review.stars >= 4 ? "active" : ""} icon={review.stars >= 4 ? StarSelected : StarUnselected} />
						<FontAwesomeIcon className={review.stars >= 5 ? "active" : ""} icon={review.stars >= 5 ? StarSelected : StarUnselected} /></h4>
						<p>{review.review}</p>
					</div>
				)
			}
			{!pending && <button id="load-more" onClick={e => loadMore(e)} disabled={loadingMore}>{loadingMore ? "Loading more reviews" : "Load 2 more reviews"}</button>}
		</section>
	)
}

const Form = () => {

	const reviewService = new ReviewService();

	const [ stars, setStars ] = useState(0);
	const [ pending, setPending ] = useState(false);
	const [ error, setError ] = useState("");
	const [ review, setReview ] = useState("");
	
	const AddReview = async (e) => {
		e.preventDefault();

		setPending(true);
		setError("");

		try {
			await reviewService.addReview(firebase.auth().currentUser.uid, stars, review);

			setPending(false);

			setStars(0);
			setReview("");
		}
		catch({ message }) {
			setError(message);
			setPending(false);
		}

	}

	return (
		<AuthProvider>	
			<IfFirebaseUnAuthed>
				<h3>Please <Link to="/auth/login">login</Link> to leave a review!</h3>
			</IfFirebaseUnAuthed>
			<IfFirebaseAuthed>
				<form onSubmit={(e) => AddReview(e)}>
					<h4>Leave a review</h4>
					{ error.length > 0 && <p className="error">{error}</p> }
					<div id="stars">
						<button type="button" onClick={() => setStars(1)} className={stars >= 1 ? "active" : ""}><FontAwesomeIcon icon={stars >= 1 ? StarSelected : StarUnselected} /></button>
						<button type="button" onClick={() => setStars(2)} className={stars >= 2 ? "active" : ""}><FontAwesomeIcon icon={stars >= 2 ? StarSelected : StarUnselected} /></button>
						<button type="button" onClick={() => setStars(3)} className={stars >= 3 ? "active" : ""}><FontAwesomeIcon icon={stars >= 3 ? StarSelected : StarUnselected} /></button>
						<button type="button" onClick={() => setStars(4)} className={stars >= 4 ? "active" : ""}><FontAwesomeIcon icon={stars >= 4 ? StarSelected : StarUnselected} /></button>
						<button type="button" onClick={() => setStars(5)} className={stars >= 5 ? "active" : ""}><FontAwesomeIcon icon={stars >= 5 ? StarSelected : StarUnselected} /></button>
					</div>
					<div id="input">
						<textarea 
							name="review"
							rows="10"
							placeholder="Write a review!"
							value={review}
							disabled={pending}
							onChange={(e) => setReview(e.target.value)}
						></textarea>
					</div>
					<button 
						type="submit"
						disabled={pending}
					>Add review</button>
				</form>
			</IfFirebaseAuthed>
		</AuthProvider>
	)

};

const Reviews = () => (
	<section id="reviews-list">
		<h1>Reviews</h1>
		<Form />
		<ReviewsList />
	</section>
);

const ReviewsPage = () => (
	<>
		<Navbar />
		<Reviews />
		<Footer />
	</>
);

export default ReviewsPage;